import React from 'react';
import Select from 'react-select';

// Custom component for options (with or without image)
const customOption = (props, includeImage) => {
  const { data, innerRef, innerProps, isFocused } = props; // Destructure isFocused for hover state

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={`flex items-start space-x-2 p-2 ${isFocused ? 'bg-gray-200' : ''}`}
    >
      <span className="whitespace-normal break-words max-w-[200px]">
        {data.label}
      </span>
      {includeImage && data.imgSrc && (
        <img src={data.imgSrc} alt={data.label} className="w-6 h-6 shrink-0" />
      )}
    </div>
  );
};

// Custom Select component
const CustomSelect = ({
  value,
  onChange,
  options,
  placeholder,
  id,
  name,
  isMulti = false,
  includeImage = false,  // Default is false to not show images
}) => {

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      fontWeight: 400, // font-medium
    }),
    control: (provided) => ({
      ...provided,
      fontWeight: 400, // optional: font for selected value
    }),
    singleValue: (provided) => ({
      ...provided,
      fontWeight: 400,
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    multiValueLabel: (base) => ({
      ...base,
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      maxWidth: '100px', // or whatever fits your layout
    }),
    singleValue: (base) => ({
      ...base,
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      maxWidth: '100px',
    }),
  };

  // Handling selected value for multi and single select
  const selectedValue = isMulti
    ? options.filter(option => (value || []).includes(option.value))
    : options.find(option => option.value === value) || null;

  return (
    // <Select
    //   id={id}
    //   name={name}
    //   value={selectedValue} 
    //   onChange={selected =>
    //     isMulti
    //       ? onChange(selected ? selected.map(option => option.value) : []) 
    //       : onChange(selected?.value || null) 
    //   }
    //   options={options} 
    //   placeholder={placeholder} 
    //   isClearable 
    //   isSearchable 
    //   isMulti={isMulti} 
    //   styles={customStyles}
    //   closeMenuOnSelect={isMulti ? false : true}
    //   getOptionLabel={(e) => e.label} // Ensure that search looks at the label text
    //   components={{
    //     Option: (props) => customOption(props, includeImage), // Use conditional customOption rendering
    //   }}
    // />
    <Select
      id={id}
      name={name}
      value={selectedValue}
      onChange={selected =>
        isMulti
          ? onChange(selected ? selected.map(option => option.value) : [])
          : onChange(selected?.value || null)
      }
      options={options}
      placeholder={placeholder}
      isClearable
      isSearchable
      isMulti={isMulti}
      styles={{
        ...customStyles,
        menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures the dropdown appears above other elements
      }}
      closeMenuOnSelect={isMulti ? false : true}
      getOptionLabel={(e) => e.label}
      components={{
        Option: (props) => customOption(props, includeImage),
      }}
      menuPortalTarget={document.body} // Moves dropdown outside of overflow-hidden containers
    />

  );
};

export default CustomSelect;
